import axiosInstance from '../axiosInstance';

/** Bậc huy chương, từ thấp đến cao. Khớp RankDiscountCalculator ở backend. */
export const MEDAL_TIERS = [
  { key: 'bronze', label: 'Đồng', unit: 1, discountKey: 'bronzeDiscount', className: 'medal-bronze' },
  { key: 'silver', label: 'Bạc', unit: 5, discountKey: 'silverDiscount', className: 'medal-silver' },
  { key: 'gold', label: 'Vàng', unit: 25, discountKey: 'goldDiscount', className: 'medal-gold' },
  { key: 'diamond', label: 'Kim cương', unit: 125, discountKey: 'diamondDiscount', className: 'medal-dimond' },
];

/**
 * Quy đổi rank ra số huy chương, giống RankDiscountCalculator.decompose:
 * rank <= 5 toàn là đồng (rank 5 = 5 đồng); lớn hơn thì bậc cao nhất là bậc có đơn vị nhỏ hơn rank,
 * phần dư chia tiếp cho bậc dưới. Ví dụ 12 = 2 bạc + 2 đồng, 25 = 5 bạc, 126 = 1 kim cương + 1 đồng.
 */
export function decomposeRank(rank) {
  const value = Math.max(0, Math.floor(Number(rank) || 0));
  if (value <= 5) {
    return { bronze: value, silver: 0, gold: 0, diamond: 0 };
  }
  let rest = value;
  const diamond = value > 125 ? Math.floor(rest / 125) : 0;
  rest -= diamond * 125;
  const gold = value > 25 ? Math.floor(rest / 25) : 0;
  rest -= gold * 25;
  const silver = Math.floor(rest / 5);
  rest -= silver * 5;
  return { bronze: rest, silver, gold, diamond };
}

let rankSettingPromise = null;

/** Cấu hình % chiết khấu từng bậc; gọi API một lần cho cả phiên trang. */
export function fetchRankDiscountSetting() {
  if (!rankSettingPromise) {
    rankSettingPromise = axiosInstance
      .get('/api/import-orders/getSetting')
      .then((response) => response?.data?.data || {})
      .catch(() => {
        rankSettingPromise = null;
        return {};
      });
  }
  return rankSettingPromise;
}
